<form [formGroup]="form" *ngIf="!loading">
  <div class="form-content">
    <div class="form-block">
      <app-form-field-selection-test-location
        [field]="testLocation"
        [label]="'label.test-event-location' | translate"
        [options]="optionsLocation"
        [multiple]="true"
        [focused]="true"
      >
      </app-form-field-selection-test-location>
    </div>

    <div class="form-block">
      <app-form-field-select
        [field]="testDate"
        [label]="'label.test-event-date' | translate"
        [options]="optionsDate"
        [multiple]="true"
        [localizeDate]="true"
      ></app-form-field-select>
    </div>
    <div class="form-block">
      <app-form-field-select
        [field]="testTime"
        [label]="'label.test-event-time' | translate"
        [options]="optionsTime"
        [multiple]="true"
      ></app-form-field-select>
    </div>
  </div>

  <div class="timeSlots">
    <app-test-time-card
      *ngFor="let examEvent of examEventsFiltered"
      [control]="examEventChosen"
      [examEvent]="examEvent"
      [name]="'timeSlotRadioGroup'"
    ></app-test-time-card>
  </div>
</form>

<app-loading-indicator-full
  *ngIf="loading"
></app-loading-indicator-full>
